"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_ejs_1 = require("./form.ejs");
const html_ejs_1 = require("./html.ejs");
exports.default = { form: form_ejs_1.default, html: html_ejs_1.default };
